import { makeStyles } from "@material-ui/core/styles";

const useStyle = makeStyles((theme) => ({
  container: {
    minHeight: 18,
  },
  editor: {
    width: "100%",
    boxSizing: "border-box",
    fontSize: "inherit",
    fontWeight: "inherit",
    color: "inherit",
    fontFamily: "inherit",
    padding: "7px 6px",
    borderRadius: 5,
    "& > .ql-container": {
      minHeight: 18,
    }
  },
  placeholderOnFocus: {
    "&:not(.focused) .ql-editor.ql-blank::before": {
      display: "none",
    }
  },
  
  borderedHover: {
    "&:hover $fieldset": {
      borderWidth: 2,
      borderColor: theme.palette.primary.main,
    }
  },
  fieldset: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    borderRadius: 5,
    borderStyle: "solid",
    borderWidth: 0,
  },
  borderedUnfocused: {
    borderWidth: 1,
    borderColor: theme.palette.text.primary,
  },
  borderedFocused: {
    borderWidth: 2,
    borderColor: theme.palette.primary.main,
  },
  mentionList: {
    width: 416,
  },
  focusLink: {
    width: "100%",
    height: "100%",
    display: "block",
    position: "absolute",
    left: 0,
    borderRadius: 5,
    outlineOffset: 2,
    pointerEvents: "none",
    "&:focus": {
      borderWidth: 2,
      borderStyle: "solid",
      borderColor: theme.palette.primary.main,
    }
  }
}));

export default useStyle;